import React, {useEffect, useState} from 'react';

import makeStyles from '@mui/styles/makeStyles';

import {useRecoilState, useRecoilValue} from 'recoil';
import {userState} from '../../recoil/user/userAtom';
import {
  removeHeaderState,
  removeFooterState,
  removeMainScrollState,
} from '../../recoil/removeAppBar/removeAppBarAtom';

import useScreenWidth from '../../common/useScreenWidth';

import {NavigationBar} from './Navigation/Header/NavigationBar';
import {FooterNavigationBar} from './Navigation/Footer/FooterNavigationBar';
import {LeftNavigation} from './Navigation/LeftMenu/LeftNavigation';
import {Dialogs} from './Navigation/Dialogs/Dialogs';
import {bidmiiProReferralBannerOpenState} from '../../recoil/dialogs/DialogsRecoil';
import {leftMenuOpenState} from '../../recoil/navigation/NavigationRecoil';
import ErrorBoundary from '../../common/ErrorBoundary';
import {useHistory} from 'react-router-dom';

interface IProps {
  children?: React.ReactNode;
}

export const MainContainer: React.FC<IProps> = (_props) => {
  const history = useHistory();
  const width = useScreenWidth();
  const user = useRecoilValue(userState);
  const [removeHeader, setRemoveHeader] = useRecoilState(removeHeaderState);
  const [removeFooter, setRemoveFooter] = useRecoilState(removeFooterState);
  const [leftMenuOpen, setLeftMenuOpen] = useRecoilState(leftMenuOpenState);
  const [isAnonymous, setIsAnonymous] = useState(
    localStorage.getItem('isAnonymous') !== null,
  );

  // Remove header and footer if in webview
  useEffect(() => {
    if ((window as any).ReactNativeWebView) {
      setRemoveHeader(true);
      setRemoveFooter(true);
    }

    return () => {
      setRemoveHeader(false);
      setRemoveFooter(false);
    };
  }, [setRemoveHeader, setRemoveFooter]);

  // useEffect(() => {
  //   if (width > 600 && !window.location.pathname.includes('/m/')) {
  //     setLeftMenuOpen(true);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  useEffect(() => {
    if (window.location.search === '?createProject=true') {
      history.push('/create-project');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.pathname]);

  useEffect(() => {
    if (user) {
      setIsAnonymous(false);
    }
  }, [user]);

  const useStyles = makeStyles((theme) => ({
    root: {},
    content: {
      flexGrow: 1,
      backgroundColor: theme.palette.gray.main,
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      [theme.breakpoints.down('sm')]: {
        overflowX: 'visible',
        marginBottom: 60,
      },
    },
  }));

  const classes = useStyles();
  const removeMainScroll = useRecoilValue(removeMainScrollState);
  const referralBannerOpen = useRecoilValue(bidmiiProReferralBannerOpenState);

  return (
    <div className={classes.root}>
      {/* PS - This component has been removed until we better understand how we want to handle meta */}
      {/* <HomeHelmet /> */}
      <NavigationBar
        isAnonymous={isAnonymous}
        removeHeader={removeHeader}
        width={width}
      />
      <LeftNavigation
        width={width}
        drawerOpen={leftMenuOpen}
        setDrawerOpen={setLeftMenuOpen}
      />
      <ErrorBoundary fallbackUi={null}>
        <main
          className={classes.content}
          style={{
            marginTop: removeHeader ? 0 : referralBannerOpen ? 120 : 64,
            marginLeft: !removeHeader && width > 600 && leftMenuOpen ? 250 : 0,
            // @ts-expect-error ts-migrate(2322) FIXME: Type 'false | "calc(100vh - 54px)"' is not assigna... Remove this comment to see the full error message
            maxHeight:
              !removeHeader && !removeMainScroll && 'calc(100vh - 54px)',
            overflowX: 'auto',
          }}>
          {_props.children}
        </main>
      </ErrorBoundary>
      <FooterNavigationBar removeFooter={removeFooter} width={width} />
      <Dialogs />
    </div>
  );
};
